var _g, _path, _rect, _rect2, _circle, _path2, _path3, _path4, _rect3, _path5, _path6, _path7, _path8, _path9, _g2, _g3, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgErrorSearch = function SvgErrorSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#errorSearch_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 71c0-6.075-4.925-11-11-11h-12.211a8.514 8.514 0 0 0-8.04 5.712 8.515 8.515 0 0 1-8.041 5.712H53a9 9 0 0 0-9 9V140a9 9 0 0 0 9 9h93c6.075 0 11-4.925 11-11V71Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157 77c0-6.075-4.925-11-11-11h-37.564a6.804 6.804 0 0 1-6.561-5 6.804 6.804 0 0 0-6.56-5H55c-6.075 0-11 4.925-11 11v71c0 6.075 4.925 11 11 11h91c6.075 0 11-4.925 11-11V77Z",
    fill: "#C5CBD1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 104,
    width: 35,
    height: 72,
    rx: 4,
    transform: "rotate(-90 65 104)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 73,
    width: 29,
    height: 27,
    rx: 2,
    fill: "#9EA4AC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.566,
    cy: 86.567,
    r: 6.566,
    fill: "#C9CED4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 90c0-1.105.949-2 2.119-2H130c1.17 0 2.119.895 2.119 2s-.949 2-2.119 2h-24.881c-1.17 0-2.119-.895-2.119-2ZM103 98c0-1.105.938-2 2.094-2h12.812c1.156 0 2.094.895 2.094 2s-.938 2-2.094 2h-12.812c-1.156 0-2.094-.895-2.094-2Z",
    fill: "#F0F4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 75c0-1.105.956-2 2.135-2H129.5c1.179 0 2.135.895 2.135 2s-.956 2-2.135 2h-24.365c-1.179 0-2.135-.895-2.135-2Z",
    fill: "#BED1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 83c0-1.105 1.048-2 2.34-2H130c1.293 0 2.34.895 2.34 2s-1.047 2-2.34 2h-24.66c-1.292 0-2.34-.895-2.34-2Z",
    fill: "#F0F4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 143,
    width: 35,
    height: 72,
    rx: 4,
    transform: "rotate(-90 65 143)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69 113.875a2 2 0 0 1 2-2h24.721a2 2 0 0 1 2 2v23.155a2 2 0 0 1-2 2H71a2 2 0 0 1-2-2v-23.155Z",
    fill: "#D7D7D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.658 118.107c1.731.207 2.905 1.733 2.671 3.461-.373 2.757-1.425 6.787-4.378 8.987-2.953 2.199-7.116 2.054-9.864 1.622-1.723-.271-2.849-1.833-2.552-3.551.46-2.654 1.617-6.483 4.533-8.654 2.916-2.172 6.916-2.185 9.59-1.865Z",
    fill: "#9EA4AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 129c0-1.105.949-2 2.119-2H130c1.17 0 2.119.895 2.119 2s-.949 2-2.119 2h-24.881c-1.17 0-2.119-.895-2.119-2ZM103 137c0-1.105.938-2 2.094-2h12.812c1.156 0 2.094.895 2.094 2s-.938 2-2.094 2h-12.812c-1.156 0-2.094-.895-2.094-2Z",
    fill: "#F0F4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 114c0-1.105.956-2 2.135-2H129.5c1.179 0 2.135.895 2.135 2s-.956 2-2.135 2h-24.365c-1.179 0-2.135-.895-2.135-2Z",
    fill: "#BED1FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 122c0-1.105 1.048-2 2.341-2H130c1.293 0 2.341.895 2.341 2s-1.048 2-2.341 2h-24.659c-1.293 0-2.341-.895-2.341-2Z",
    fill: "#F0F4FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#errorSearch_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 70c0-6.075-4.925-11-11-11h-12.766a7.53 7.53 0 0 0-7.171 5.231",
    fill: "url(#errorSearch_svg__c)",
    fillOpacity: 0.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#errorSearch_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.429 55.714c0 9.784-7.931 17.715-17.715 17.715-9.783 0-17.714-7.931-17.714-17.715C139 45.931 146.931 38 156.714 38c9.784 0 17.715 7.93 17.715 17.714Z",
    fill: "#5981E3"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.657 59.455h-3.413l-.717-13.68h4.847l-.717 13.68Zm-4.188 4.79c0-.88.239-1.492.717-1.836.478-.364 1.061-.545 1.75-.545.669 0 1.243.181 1.721.545.478.344.717.956.717 1.835 0 .842-.239 1.453-.717 1.836-.478.363-1.052.545-1.721.545-.689 0-1.272-.182-1.75-.545-.478-.383-.717-.994-.717-1.836Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "errorSearch_svg__a",
    x: 41,
    y: 57,
    width: 119,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4015_54868"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4015_54868",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "errorSearch_svg__b",
    x: 38,
    y: 53,
    width: 125,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4015_54868"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4015_54868",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "errorSearch_svg__d",
    x: 137,
    y: 37,
    width: 39.429,
    height: 39.428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4015_54868"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4015_54868",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "errorSearch_svg__c",
    x1: 40.5,
    y1: 44.5,
    x2: 100.872,
    y2: 148.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CED3"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErrorSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/errorSearch.svg";